import { useLayoutEffect, useState } from "react";

import useTeacherLanguageGet from "@/teacher/hooks/useTeacherLanguageGet";
import useTeacherLanguagePost from "@/teacher/hooks/useTeacherLanguagePost";

const useTeacherLanguageMutation = (id) => {
  const initialResponse = useTeacherLanguageGet(id);
  const [postMethod] = useTeacherLanguagePost(id);
  const [response, setResponse] = useState(initialResponse);

  useLayoutEffect(() => {
    setResponse(initialResponse);
  }, [initialResponse]);

  const onMutationCallMiddleware = (mutationFn) => {
    return async (...args) => {
      setResponse((values) => ({ ...values, loading: true }));
      const response = await mutationFn(...args);
      setResponse((values) => ({ ...values, ...response, loading: false }));
      return response;
    };
  };

  return {
    response,
    postMethod: onMutationCallMiddleware(postMethod),
  };
};

export default useTeacherLanguageMutation;
